import React, { useMemo } from "react";
import { ProcessedScanResult } from "../SpaceScanner.types";
import { calculateOptimisationScore } from "../../../../../services/ai/SpaceOptimiserAI";

interface OptimisationScoreProps {
  results: ProcessedScanResult[];
}

const SCORE_COLOURS: Record<string, string> = {
  Excellent: "var(--progressLow, #22c55e)",
  Good: "var(--infoButtonSolid, #3b82f6)",
  Fair: "var(--progressMed, #f59e0b)",
  "Needs Attention": "var(--progressHigh, #ef4444)",
  "No Data": "var(--secondaryColor, #6b7280)",
  "N/A": "var(--secondaryColor, #6b7280)"
};

export const OptimisationScore = ({
  results
}: OptimisationScoreProps): React.ReactElement => {
  const { score, label, explanation } = useMemo(
    () => calculateOptimisationScore(results),
    [results]
  );

  const colour = SCORE_COLOURS[label] ?? "var(--secondaryColor, #6b7280)";

  return (
    <section
      className="my-3 flex items-center gap-3 rounded-lg border border-[var(--borderColor)] p-3"
      aria-label="Optimisation score"
    >
      <span
        className="flex size-10 flex-shrink-0 items-center justify-center rounded-full text-sm font-bold text-white"
        style={{ backgroundColor: colour }}
        aria-label={`Score: ${score}%`}
      >
        {score}
      </span>
      <div className="min-w-0 flex-1">
        <span className="text-sm font-semibold" style={{ color: colour }}>
          {label}
        </span>
        <p className="mt-0.5 text-xs text-[var(--secondaryColor)]">
          {explanation}
        </p>
      </div>
    </section>
  );
};
